import React from 'react';
import { IconPropType } from '../../../../Interfaces/IconPropType';
import { neutral } from '../../../../style/colors';
export const Share = (props: IconPropType) => {
  const { width, height, color, style, onClick } = props;
  return (
    <svg
      onClick={onClick ? () => onClick() : () => {}}
      style={style}
      width={width ? width : height ? height * (114 / 102) : 114}
      height={height ? height : width ? width * (102 / 114) : 102}
      viewBox="0 0 114 102"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        id="Icons"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g
          id="Desktop-HD"
          transform="translate(-120.000000, -738.000000)"
          fill={color ? color : neutral[600]}
          fillRule="nonzero"
          stroke={color ? color : neutral[600]}
          strokeWidth="0.5"
        >
          <path
            d="M233.5,743.6875 L233.5,768.684375 C233.5,772.875977 228.429688,774.930469 225.497852,771.999023 L218.523828,765.024609 L170.960742,812.587695 C169.130078,814.418359 166.162305,814.418359 164.331641,812.587695 L159.912305,808.168359 C158.081641,806.337695 158.081641,803.369727 159.912305,801.539258 L207.475781,753.975781 L200.502539,747.002148 C197.558984,744.058594 199.64375,739 203.817187,739 L228.8125,739 C231.401367,739 233.5,741.098633 233.5,743.6875 Z M200.497852,791.889453 L197.372852,795.014453 C196.493767,795.893553 195.999933,797.085878 196,798.329102 L196,826.5 L133.5,826.5 L133.5,764 L185.0625,764 C186.305639,763.999929 187.497853,763.506112 188.376953,762.627148 L191.501953,759.502148 C194.454883,756.549023 192.363477,751.5 188.1875,751.5 L130.375,751.5 C125.197266,751.5 121,755.697266 121,760.875 L121,829.625 C121,834.802734 125.197266,839 130.375,839 L199.125,839 C204.302734,839 208.5,834.802734 208.5,829.625 L208.5,795.203906 C208.5,791.027734 203.450781,788.936328 200.497852,791.889453 Z"
            id="Share"
          />
        </g>
      </g>
    </svg>
  );
};

export default Share;
